export const alertsRoutes = {
  list: "",
  settings: "settings",
} as const;
